import $ from 'jquery';

/**
 * @fileOverview View handles updating the visual elements on the page
 */
export default class SideMenuView {
    /**
     * Construct the view and run initialization
     *
     * @param element
     */
    constructor(element) {
        this.selector = element;
        /**
         * Check to see if elements are passed in as jQuery objects or strings
         */
        this.$element = (element instanceof $) ? element : $(element);

        /**
         * If element doesn't exist, exit early
         */
        if (!this.$element.length) {
            return;
        }

        this.init();
    }

    /**
     * Initialize the view
     *
     * @method init
     */
    init() {
        this.isEnabled = false;
        this.isActive = false;

        return this.setupHandlers()
                   .createChildren()
                   .layout()
                   .enable();
    }

    /**
     * Binds the scope of handler functions
     * Should be run once on view initialization
     *
     * @method setupHandlers
     * @returns {SideMenuView}
     */
    setupHandlers() {
        this.handleMenuClick = this.onMenuClick.bind(this);
        this.handleAnyClick = this.onAnyClick.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);

        return this;
    }

    /**
     * Create any child objects and references to DOM elements
     * Should only be run once on init of the view
     *
     * @method createChildren
     * @returns {SideMenuView}
     */
    createChildren() {
        return this;
    }

    /**
     * Update the DOM to reflect the current state of the model
     *
     * @method layout
     * @returns {SideMenuView}
     */
    layout() {
        return this;
    }

    /**
     * Disable, update the DOM, and then re-enable to create handlers for new DOM
     *
     * @method render
     */
    render() {
        this.disable();
        this.layout();
        this.enable();
    }

    /**
     * Enables the view
     * Performs binding to handlers
     * Exits early if already enabled
     *
     * @method enable
     * @returns {SideMenuView}
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }

        this.isEnabled = true;

        for (let i = 0; i < this.$element.length; i++) {
            this.$element[i].addEventListener('click', this.handleMenuClick);
        }

        $('html').on('click', this.handleAnyClick);
        $('html').on('touchend', this.handleAnyClick);

        document.addEventListener('keydown', this.handleKeydown);

        return this;
    }

    /**
     * Disables the view
     * Tears down any event binding to handlers
     * Exits early if it is already disabled
     *
     * @method disable
     * @returns {SideMenuView}
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }

        for (let i = 0; i < this.$element.length; i++) {
            this.$element[i].removeEventListener('click', this.handleMenuClick);
        }

        document.removeEventListener('keydown', this.handleKeydown);

        this.isEnabled = false;

        return this;
    }

    /**
     * Destroys the view
     * Tears down any events, handlers, elements
     * Should be called when the object should be left unused
     *
     * @method destroy
     * @returns {SideMenuView}
     */
    destroy() {
        this.disable();

        return this;
    }

    /**
     * Handles open click event
     *
     * @param event
     * @returns {SideMenuView}
     */
    onMenuClick(event) {
        const $target = $(event.currentTarget);

        if (this.isActive) {
            this.closeDrawer();
        } else {
            this.openDrawer();
        }

        return this;
    }

    /**
     * Watch for page clicks and close the dropdown if it is outside the dropdown area
     *
     * @param event
     */
    onAnyClick(event) {
        const $target = $(event.target);

        if (this.isActive && $target.closest(this.$element).length === 0) {
            this.closeDrawer();
            this.isActive = false;
        }
    }

    /**
     * Handles keydown event
     * Close menu if user hits ESC
     *
     * @param event
     * @returns {SideMenuView}
     */
    onKeydown(event) {
        if ((this.isActive == true) && ((!event.keyCode) || (event.keyCode === 27))) {
            this.closeDrawer();
            this.$element.focus();
        }

        return this;
    }

    /**
     * Opens nav drawer
     * @returns {SideMenuView}
     */
    openDrawer() {
        this.addGap();
        this.$element.addClass('open');
        this.isActive = true;
        return this;
    }

    /**
     * Close nav drawer
     * @returns {SideMenuView}
     */
    closeDrawer() {
        this.removeGap();
        this.$element.removeClass('open');
        this.isActive = false;
        return this;
    }

    /**
     * Offset the height lost when the input is made to be absolutely positioned
     * @returns {SideMenuView}
     */
    addGap() {
        const inputHeight = this.$element.parent().height();
        console.log(inputHeight);
        this.$element.parent().height(inputHeight);
        return this;
    }

    /**
     * Remove height offset
     * @returns {SideMenuView}
     */
    removeGap() {
        this.$element.parent().removeAttr('style');
        return this;
    }
}
